const emailAddressRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function isValidEmail(email: string) {
    return emailAddressRegex.test(email) === true;
}

function isEmptyOrSpaces(str: string) {
    return !str || str.trim() === "";
}

export { emailAddressRegex, isValidEmail, isEmptyOrSpaces };
